import { Box, Container } from "@mui/material";
import React from "react";
import usePageName from "../../../hocs/usePageName";
import PickupDetails from "../../admin/ReadyForPickup/PickupDetails";

const PickupDetailsPage = () => {
  usePageName({
    heading: "Pickup Details",
    caption: null,
  });
  return (
    <Container>
      <PickupDetails />
    </Container>
  );
};

export default PickupDetailsPage;
